




















































































































import { defineComponent, toRefs, PropType, computed, watch, ref, onMounted } from '@vue/composition-api';
import {
  AdgroupFormData,
  FullNormalFormData,
  PRODUCT_SPECIFIC_TYPE,
  CreativeConfig,
  CampaignFormData,
  ACTION_TYPE,
  PRODUCTS_MAX_NUM,
  PRODUCTS_CLA_MAX_NUM,
  DpaLocalAudience,
  catalogProductFormFields,
  StoreType,
} from '@tt4b/ttam-enums';
import ProductDetails from './index';
import {
  useProductDetailValidate,
  useJumpCatalog,
  useCreativeActionTypeIs,
  useStdAdgroupIs,
  useStdCampaignIs,
} from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../utils/index';
import { getCreateModeTeaParams } from './hooks';
import TipAlert from '@/components/common/tip-alert/index.vue';
import { i18n } from './../../../i18n';

const name = 'ttam-product-details-catalog-compose';
export default defineComponent({
  name,
  components: {
    TtamProductDetailsSource: ProductDetails.TtamProductDetailsSource,
    TtamProductDetailsDesc: ProductDetails.TtamProductDetailsDesc,
    TtamProductDetailsSpecificType: ProductDetails.TtamProductDetailsSpecificType,
    TtamProductDetailsProductSet: ProductDetails.TtamProductDetailsProductSet,
    TtamProductDetailsProductList: ProductDetails.TtamProductDetailsProductsList,
    TtamProductDetailsProductsListActions: ProductDetails.TtamProductDetailsProductsListActions,
    TipAlert,
  },
  props: {
    // 用于区分汽车广告
    catalogType: {
      type: Number,
      default: StoreType.ECOM,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      required: true,
      default: () => ({} as FullNormalFormData),
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: ACTION_TYPE.CREATE,
    },
    // 错误字段map，初始化后的报错信息
    errorsMap: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({}),
    },
  },
  setup(props, { emit, refs }) {
    const { adgroupData, creativeData, creativeConfig, campaignData, createMode, errorsMap, catalogType } =
      toRefs(props);
    const catalogInfo = ProductDetails.useCatalogInfo({ adgroupData, catalogType });
    const { productSetList, getProductSet, isLoadingPsetList } = ProductDetails.usePropsSetList({
      adgroupData,
      catalogType,
    });
    const { isCLA } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });

    const showAllProductAlert = computed(() => {
      // The alert should only work under `retarget` and not `all products` select.
      const notAll = creativeData.value.productSpecificType !== PRODUCT_SPECIFIC_TYPE.ALL;
      const fromRetarget = adgroupData.value.dpaLocalAudience === DpaLocalAudience.Retarget;
      return notAll && fromRetarget;
    });

    const { isLeadAdsAutoInventoryAds } = useStdCampaignIs({
      campaignFormData: campaignData,
    });

    const { isEdit, isCopy } = useCreativeActionTypeIs({ createMode, adgroupFormData: adgroupData });

    const title = computed(() =>
      isLeadAdsAutoInventoryAds.value
        ? i18n.t('creative_aia_product_details')
        : i18n.t('module_product_selected_details_title'),
    );

    const formFieldsConfig = computed(() => catalogProductFormFields?.[catalogType.value]);

    const formItemPropField = computed(() => formFieldsConfig.value?.PRODUCT_SET_ID);
    // 取值: creativeData.productSpecificType / creativeData.supplySelection
    const _productSpecificType = computed(() => creativeData.value?.[formFieldsConfig.value?.PRODUCT_TYPE]);

    const catalogId = computed(() => adgroupData.value?.[formFieldsConfig.value?.CATALOG_ID]);
    const bcId = computed(() => adgroupData.value?.[formFieldsConfig.value?.BC_ID]);

    const { jumpPsetPage: onCreatePset, jumpProductPage } = useJumpCatalog(catalogId, bcId);

    const isHideCreateOperation = computed(() => isLeadAdsAutoInventoryAds.value);

    const isShowProductSet = computed(() => _productSpecificType.value === PRODUCT_SPECIFIC_TYPE.PRODUCT_SET);
    const isShowProductSelect = computed(() => _productSpecificType.value === PRODUCT_SPECIFIC_TYPE.PRODUCTS);

    const _productSetId = computed({
      get() {
        // const creativeSetId = creativeData.value.productSetId;
        const creativeSetId = creativeData.value?.[formFieldsConfig.value?.PRODUCT_SET_ID] ?? '';
        return creativeSetId;
      },
      set(val) {
        emit('products-detail-product-set-change', val);
      },
    });

    const productSet = computed(() => productSetList.value?.find?.(set => set.id === _productSetId.value));

    const showProdApprovedCountAlert = computed(() => {
      if (isShowProductSet.value) {
        return productSet.value?.prod_approved_count < 1 && productSet.value?.count > 0;
      }
      return catalogInfo.value?.prod_approved_count < 1 && catalogInfo.value?.prod_sum > 0;
    });

    const onSpecificTypeChange = val => {
      emit('products-detail-specific-type-change', val);
    };
    const onProductSetChange = val => {
      _productSetId.value = val;
      trackEvent('module_ad_creative_nonshop_product_set_choose');
    };

    const onProductListRemove = () => {
      trackEvent('module_ad_creative_nonshop_delete_products_click', getCreateModeTeaParams({ isEdit, isCopy }));
    };

    // @@@@ 没有修改取值逻辑
    const { productListDataSource, onProductListChange } = ProductDetails.useProductListForCatalog({
      creativeData,
      emit,
    });

    // @@@@ 没有修改取值逻辑
    const { openDrawer, clear } = ProductDetails.useListActions(emit);

    const { productSetIdValidator, dpaProductsValidator } = useProductDetailValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      catalogType,
    });

    onMounted(() => {
      if (isCopy.value) {
        // copy的时候进页面就需要校验一下
        refs.dpaProductsFormItem?.validate('change');
      }
    });

    watch([() => _productSpecificType.value], () => {
      refs.productSetFormItem?.clearValidate();
      refs.dpaProductsFormItem?.clearValidate();
    });
    watch(
      () => productListDataSource.value?.length,
      () => {
        refs.dpaProductsFormItem?.validate('change');
      },
    );

    watch(
      () => catalogId.value,
      () => {
        // 目的: AIA 1NN新建在不同creative（非同一ad group下）下切换时,pset list需要重新获取
        // 仅在isLeadAdsAutoInventoryAds执行，是为了避免对VSA的影响 VSA不需要监听catalog_id重新获取列表
        if (isLeadAdsAutoInventoryAds.value) {
          getProductSet({
            catalog_id: catalogId.value ?? '',
            bc_id: bcId.value ?? '',
          });
        }
      },
    );

    return {
      name,
      isEdit,
      catalogInfo,
      _productSetId,
      productSetList,
      showProdApprovedCountAlert,
      productSet,
      onSpecificTypeChange,
      onProductSetChange,
      formItemPropField,
      isLoadingPsetList,
      isShowProductSet,
      isShowProductSelect,
      showAllProductAlert,
      productListDataSource,
      onProductListChange,
      onProductListRemove,
      openDrawer,
      clear,
      productSetIdValidator,
      dpaProductsValidator,
      onCreatePset,
      jumpProductPage,
      getProductSet,
      isCLA,
      title,
      PRODUCTS_MAX_NUM,
      PRODUCTS_CLA_MAX_NUM,

      _productSpecificType,
      isHideCreateOperation,
    };
  },
});
